import { Caption1, Caption2, Flex, H5, H6 } from '@components/atoms'
import React, { useState } from 'react'
import { arrow_down, check_img } from '@images/index'
import { check_empty_img, check_img_blue, open_alarm_talk_img } from '@images/'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import Textarea from 'react-textarea-autosize'

import { PIXEL_EVENTS } from '@utils/facebook/pixelLogs'
import ReactDOM from 'react-dom'
import { colors } from '@colors/'
import { pixelTrack } from '@utils/facebook/pixel'
import styled from 'styled-components'
import { useSnackBar } from '..'

const usePopup = () => {
  const [isShowing, setIsShowing] = useState(false)

  function toggle() {
    !isShowing ? disableBodyScroll() : enableBodyScroll()
    setIsShowing(!isShowing)
  }

  return {
    isShowing,
    toggle,
  }
}

const View = ({ isShowing, toggle, onCancel, requestOpen, toggleComplte }) => {
  const [isShowPrivacy, setIsShowPrivacy] = useState(false)
  const [isCheck, setIsCheck] = useState(false)
  const [nameValue, setNameValue] = useState('')
  const [linkValue, setLinkValue] = useState('')
  const [emailVal, setEmailVal] = useState('')
  const { toggleSnackBar, View: SnackBar } = useSnackBar()
  const {
    View: VallidationView,
    toggleSnackBar: handleVallidation,
  } = useSnackBar()

  const {
    View: VallidationLinkView,
    toggleSnackBar: handleVallidationLink,
  } = useSnackBar()

  const {
    View: VallidationNameView,
    toggleSnackBar: handleVallidationName,
  } = useSnackBar()

  const {
    View: RequestErrorView,
    toggleSnackBar: handleRequestError,
  } = useSnackBar()

  const handleCancel = () => {
    pixelTrack(PIXEL_EVENTS.덕력고사5.알림취소)
    if (onCancel) {
      onCancel()
    }
    toggle()
  }

  const validatePhoneNumber = value => {
    const phoneRegex = /^01[0-9]\d{7,8}$/
    return phoneRegex.test(value)
  }

  const validateEmail = value => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(value)
  }

  const validateLink = value => {
    const linkRegex = /^https:\/\//

    return linkRegex.test(value)
  }

  const handleOk = async () => {
    pixelTrack(PIXEL_EVENTS.덕력고사5.알림)
    // if (typeof window.twq === 'function') {
    //   window.twq('event', 'tw-owc18-p5w9j')
    // }

    if (!isCheck) {
      toggleSnackBar()
      return
    }

    if (!validateEmail(emailVal)) {
      handleVallidation()
      return
    }

    if (!linkValue || !validateLink(linkValue)) {
      handleVallidationLink()
      return
    }

    if (!nameValue) {
      handleVallidationName()
      return
    }

    if (requestOpen) {
      const requestResult = await requestOpen(emailVal, linkValue, nameValue)
      if (requestResult) {
        toggle()
        toggleComplte()
      }
      else {
        handleRequestError()
      }
    }
  }

  return (
    <>
      <SnackBar
        text={'Vui lòng đồng ý với việc thu thập và sử dụng thông tin cá nhân'}
        backgroundColor="#ea4653"
      />
      <VallidationView
        text={'Vui lòng kiểm tra định dạng email'}
        backgroundColor="#ea4653"
      />
      <VallidationLinkView
        text={'Vui lòng kiểm tra liên kết video đã tải lên'}
        backgroundColor="#ea4653"
      />
      <VallidationNameView
        text={'Vui lòng nhập tên của bạn'}
        backgroundColor="#ea4653"
      />
      <RequestErrorView
        text={'Vui lòng thử lại sau'}
        backgroundColor="#ea4653"
      />
      {
        isShowing
        && ReactDOM.createPortal(
          <>
            <ModalOverlay />
            <ModalWrapper aria-modal aria-hidden tabIndex={-1} role="dialog">
              <Modal>
                <MobdlBody>
                  <Flex type={'column'} style={{ padding: '0px 20px' }}>
                    <H5 style={{ marginTop: 24, whiteSpace: 'pre-line' }}>
                      {'Điền thông tin đăng kí tham gia'}
                    </H5>
                    <img
                      src={open_alarm_talk_img}
                      alt="open_icon"
                      style={
                        {
                          width: 48,
                          height: 48,
                          margin: '16px 0',
                          alignSelf: 'center',
                        }
                      }
                    />
                    <Caption1 align="center" style={{ whiteSpace: 'pre-line' }}>
                      {
                        'Sau khi kiểm tra các video được đăng kí\nkết quả sẽ được thông báo qua địa chỉ email.'
                      }
                    </Caption1>
                    <Flex type="column" style={{ margin: '8px 0 16px 0' }}>
                      <Caption1
                        type="Regular"
                        align="center"
                        color={colors.brownish_grey}
                      >
                        {
                          'Vui lòng nhập chính xác để không bỏ lỡ email thông báo.'
                        }
                      </Caption1>
                    </Flex>
                    <NameInput
                      placeholder="Vui lòng nhập họ tên người đăng kí."
                      style={{ marginBottom: 16 }}
                      value={nameValue}
                      onChange={e => setNameValue(e.target.value)}
                      required
                      minRows={1}
                      maxRows={5}
                    />
                    <LinkInput
                      placeholder="Dán link video đã đăng vào đây."
                      style={{ marginBottom: 16 }}
                      value={linkValue}
                      onChange={e => setLinkValue(e.target.value)}
                      required
                      minRows={1}
                      maxRows={5}
                    />
                    <EmailInput
                      placeholder="Vui lòng điền địa chỉ email."
                      type="email"
                      style={{ marginBottom: 16 }}
                      value={emailVal}
                      onChange={e => setEmailVal(e.target.value)}
                      required
                    />
                  </Flex>
                  <Flex
                    align={'center'}
                    justify={'space-between'}
                    style={{ padding: '12px 20px' }}
                  >
                    <Flex
                      onClick={() => setIsCheck(!isCheck)}
                      style={{ cursor: 'pointer' }}
                      align={'center'}
                    >
                      <img
                        src={check_img}
                        alt="checkbox_icon"
                        style={
                          {
                            width: 24,
                            height: 24,
                            marginRight: 8,
                            opacity: isCheck ? 1 : 0.5,
                          }
                        }
                      />
                      <Caption1>
                        <Caption1 type={'Regular'} color={'#949494'}>
                          (Bắt buộc)
                        </Caption1>
                        {' '}
                        Đồng ý thu thập thông tin cá nhân
                      </Caption1>
                    </Flex>
                    <Flex
                      style={
                        {
                          cursor: 'pointer',
                        }
                      }
                      onClick={
                        () => {
                          setIsShowPrivacy(val => !val)
                        }
                      }
                    >
                      <img
                        src={arrow_down}
                        alt={'arrow_img'}
                        style={
                          {
                            width: '16px',
                            height: '16px',
                            rotate: isShowPrivacy ? '180deg' : '360deg',
                          }
                        }
                      />
                    </Flex>
                  </Flex>
                  {
                    isShowPrivacy && (
                      <Flex
                        type={'column'}
                        style={{ background: '#FAFAFA', padding: '16px 20px' }}
                      >
                        <Caption2 align="left" style={{ marginBottom: '6px' }}>
                        Đồng ý thu thập thông tin cá nhân
                        </Caption2>
                        <Caption2 align="left" type="Regular">
                          {
                            'Plam thu thập và sử dụng link video và địa chỉ email để thông báo kết quả cho sự kiện mà người dùng đăng ký và sẽ bị hủy ngay sau khi thông báo sản phẩm. Bạn có thể từ chối đồng ý sử dụng việc thu thập thông tin cá nhân và nếu như vậy thì rất khó để chúng tôi thông báo kết quả cho người nhận.'
                          }
                        </Caption2>
                      </Flex>
                    )
                  }
                  {/* footer */}
                  <Flex
                    style={{ justifyContent: 'flex-end', marginTop: '30px' }}
                  >
                    <CancelBtn onClick={handleCancel}>
                      <H6>Hủy</H6>
                    </CancelBtn>
                    <Okbtn
                      onClick={handleOk}
                      disabled={
                        !isCheck || !linkValue || !emailVal || !nameValue
                      }
                    >
                      <H6>Đăng kí</H6>
                    </Okbtn>
                  </Flex>
                </MobdlBody>
              </Modal>
            </ModalWrapper>
          </>,
          document.body,
        )
      }
    </>
  )
}

export default {
  View,
  usePopup,
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
  min-width: 300px;
  z-index: 8;
`

const Modal = styled.div`
  position: fixed;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9;
  background: white;
  overflow: auto;
  max-width: 380px;
  min-width: 280px;
  width: calc(100% - 40px);
  /* min-height: 474px; */
  height: fit-content;
  top: 50%;
`

const MobdlBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* padding: 20px; */
`

const ModalWrapper = styled.div`
  min-width: 260px;
  outline: 0;
  z-index: 9;
  position: relative;
`

const NameInput = styled(Textarea)`
  /* width: calc(100% - 40px); */
  /* height: 48px; */
  font-size: 13px;
  font-family: Pretendard-Regular;
  border: solid 0.5px #d4d4d4;
  border-radius: 2px;
  box-sizing: border-box;

  background: #fff;
  padding: 11.5px 12px;
  margin: 0px;
  resize: none;
  line-height: 16px;
`
const LinkInput = styled(Textarea)`
  /* width: calc(100% - 40px); */
  /* height: 48px; */
  font-size: 13px;
  font-family: Pretendard-Regular;
  border: solid 0.5px #d4d4d4;
  border-radius: 2px;
  box-sizing: border-box;

  background: #fff;
  padding: 11.5px 12px;
  margin: 0px;
  resize: none;
  line-height: 16px;
`

const EmailInput = styled.input`
  /* width: calc(100% - 40px); */
  /* height: 48px; */
  font-size: 13px;
  font-family: Pretendard-Regular;
  border: solid 0.5px #d4d4d4;
  border-radius: 2px;

  background: #fff;
  padding: 11.5px 12px;
  margin: 0px;
`

const CancelBtn = styled.button`
  display: flex;
  height: 44px;
  padding: 5.5px 13px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  font-size: 14px;
  font-family: Pretendard-Regular;
  border: none;
  background: var(--grey-grey_40, #d4d4d4);
  color: #646464;
  cursor: pointer;
`

const Okbtn = styled.button`
  display: flex;
  height: 44px;
  padding: 5.5px 13px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  font-size: 14px;
  font-family: Pretendard-Regular;
  border: none;
  border-radius: 0px 0px 2px 0px;
  background: var(--grey-grey_80, #242424);
  cursor: pointer;
  color: var(--grey-grey_10, #fafafa);
  opacity: ${props => (props.disabled ? 0.16 : 1)};
`
